"use client";

import { useContext, useState } from "react";
import { cn } from "@/lib/utils";
import { historyAndFavouriteSections } from "@/components/common/history-and-favourite/sections";
import { UserContext } from "@/contexts/user-context";
import { HistoryAndFavouriteList } from "@/components/common/history-and-favourite/components/history-and-favourite-list";

export const HistoryAndFavourite = ({
  historyItems,
  favouriteItems,
  section,
  historyItemsLabel = "Ostatnio używane",
}: {
  historyItems?: HistoryAndFavouriteRawItem[];
  favouriteItems?: HistoryAndFavouriteRawItem[];
  section?: HistoryAndFavouriteSection;
  historyItemsLabel?: string;
}) => {
  const [active, setActive] = useState(historyItems ? "history" : "favourite");
  const { isLoggedIn } = useContext(UserContext);

  if (!isLoggedIn) {
    return null;
  }

  const headingStyles = (active: boolean) =>
    cn(
      `w-auto px-2 flex items-center gap-2 py-1.5 leading-5 whitespace-nowrap hover:cursor-pointer text-base-foreground text-sm font-medium`,
      "sm:px-4 sm:py-3.5",
      active
        ? "border-remedium-blue border-b focus:outline-none"
        : "border-b text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 focus:border-zinc-400 focus:text-zinc-700 focus:outline-none",
    );
  const { createItemPath, historyLink, favouriteLink } = section
    ? historyAndFavouriteSections[section]
    : { createItemPath: null, historyLink: null, favouriteLink: null };
  const buttonItemsCountStyles = `bg-remedium-blue/5 text-remedium-blue px-2 py-1 text-xs font-semibold rounded-md`;
  return (
    <div>
      <div className={"mb-4 flex w-full"}>
        {[
          { id: "history", label: historyItemsLabel, items: historyItems },
          { id: "favourite", label: "Zapisane", items: favouriteItems },
        ]
          .filter(({ items }) => items)
          .map(({ id, label, items }) => (
            <button
              key={id}
              onClick={() => setActive(id)}
              className={headingStyles(active === id)}
            >
              {label}
              <div className={buttonItemsCountStyles}>
                {items.length < 6 ? items.length : "5+"}
              </div>
            </button>
          ))}
        <div className={"w-full border-b"}></div>
      </div>
      {historyItems && active === "history" && (
        <HistoryAndFavouriteList
          items={historyItems}
          link={historyLink}
          createItemPath={createItemPath}
          section={section}
        />
      )}

      {favouriteItems && active === "favourite" && (
        <HistoryAndFavouriteList
          items={favouriteItems}
          link={favouriteLink}
          createItemPath={createItemPath}
          section={section}
          isFavourite={true}
        />
      )}
    </div>
  );
};
